"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpAccordion = void 0;
const accordion_html_1 = __importDefault(require("./accordion.html"));
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
let ItpAccordion = class ItpAccordion extends vue_1.default {
    elementType;
    isOpen;
    noBorder;
    get toggleIconClass() {
        return this.isOpen ? 'fa-angle-down' : 'fa-angle-right';
    }
    get cardClass() {
        let result = {
            'itp-accordion': true,
            'itp-accordion--open': true,
            shadow: false,
            'list-group-item': false,
            card: false
        };
        if (this.isOpen) {
            result['shadow'] = true;
        }
        if (this.isOpen && this.noBorder !== true) {
        }
        if (this.elementType.toLowerCase() === 'li') {
            result['list-group-item'] = true;
        }
        if (this.elementType.toLowerCase() === 'div') {
            result['card'] = true;
        }
        if (this.noBorder) {
        }
        return result;
    }
    get cardHeaderClass() {
        return 'border-bottom-0';
    }
    toggle() {
        this.$emit('toggle', { state: !this.isOpen });
    }
};
exports.ItpAccordion = ItpAccordion;
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'DIV' }),
    __metadata("design:type", String)
], ItpAccordion.prototype, "elementType", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpAccordion.prototype, "isOpen", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpAccordion.prototype, "noBorder", void 0);
exports.ItpAccordion = ItpAccordion = __decorate([
    (0, vue_property_decorator_1.Component)({ template: accordion_html_1.default })
], ItpAccordion);
//# sourceMappingURL=accordion.js.map